import { styled } from '@mui/material/styles'
import { Stack } from '@mui/material'

export const StyledStack = styled(Stack)({
  '& > * + *': {
    marginLeft: 8,
  },
})
